import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 10px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-end: 90px;
  }
  ${color}
`
